export default __webpack_public_path__ + "static/media/how-to-withdrawal-video.3df6d02f.mp4";